import {useMutation} from "@tanstack/react-query";

import {editServiceDescriptionMutationOptions} from "./edit-service-description.mutation-options";

export function useEditServiceDescription(
  id: string,
  language: Parameters<typeof editServiceDescriptionMutationOptions>[1],
) {
  return useMutation(editServiceDescriptionMutationOptions(id, language));
}
